import { useEffect } from 'react'
import { ALL_ELEMENTS, ELEMENTS, PARAMETER_EVENT, WIDGET_CLASS_ATTRIBUTES } from '../../utils/constants';
import { activeIcon } from '../../utils';

const useOrientationAdjustment = () => {

    let html = document.getElementsByTagName("html")[0];
    let body = document.getElementsByTagName("body")[0];

    useEffect(() => {
        //  USEFUL LINKS  //
        const domainName = window.location.hostname;
        const useFulTags = document.querySelectorAll("a");
        const targetId = document.getElementById("UseFulLinks");
        const processedLinks = new Set();

        for (let i = 0; i < useFulTags.length; i++) {
            const aLinksVal = useFulTags[i].getAttribute("href");
            if (
                useFulTags[i].innerText.trim() &&
                aLinksVal &&
                aLinksVal.trim() &&
                aLinksVal.trim() !== "#" &&
                !processedLinks.has(aLinksVal)
            ) {
                const optionTag = document.createElement("option");
                const ainnerHtml = useFulTags[i].innerHTML;
                optionTag.innerHTML = ainnerHtml;
                let val = aLinksVal;

                // Check if the href value is a relative URL
                if (!/^https?:\/\//i.test(aLinksVal)) {
                    // Prepend the domain name to the relative URL
                    val = `https://${domainName}${aLinksVal}`;
                }

                optionTag.setAttribute("value", val);
                targetId.appendChild(optionTag);
                processedLinks.add(aLinksVal);
            }
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    //  WHITE CURSER  //
    function cursorWhite(CheckMark) {
        let isboxId = document.querySelector("#curserWhite");

        const enableWhiteCursor = () => {
            cursorBlack(PARAMETER_EVENT.REMOVE);
            body.classList.add("rcpCurserWhite");
            isboxId.classList.add("rcpEnableFeature");
            localStorage.setItem("rcp-white-cursor", PARAMETER_EVENT.OPEN);
            activeIcon(PARAMETER_EVENT.BLOCK);
        };

        const disableWhiteCursor = () => {
            body.classList.remove("rcpCurserWhite");
            isboxId.classList.remove("rcpEnableFeature");
            localStorage.removeItem("rcp-white-cursor");
            activeIcon(PARAMETER_EVENT.NONE);

        };

        if (CheckMark === PARAMETER_EVENT.TOGGLE) {
            (body.classList.contains("rcpCurserWhite") && isboxId.classList.contains("rcpEnableFeature")) ? disableWhiteCursor() : enableWhiteCursor();
        } else if (CheckMark === PARAMETER_EVENT.ONLOAD) {
            enableWhiteCursor();
        } else if (CheckMark === PARAMETER_EVENT.REMOVE) {
            disableWhiteCursor();
        }
    }

    //  BLACK CURSOR  //
    function cursorBlack(CheckMark) {
        let isboxId = document.querySelector("#blackCursor");

        const enableBlackCursor = () => {
            cursorWhite(PARAMETER_EVENT.REMOVE);
            body.classList.add("rcpCursorBlack");
            isboxId.classList.add("rcpEnableFeature");
            localStorage.setItem("rcp-black-cursor", PARAMETER_EVENT.OPEN);
            activeIcon(PARAMETER_EVENT.BLOCK);
        };

        const disableBlackCursor = () => {
            body.classList.remove("rcpCursorBlack");
            isboxId.classList.remove("rcpEnableFeature");
            localStorage.removeItem("rcp-black-cursor");
            activeIcon(PARAMETER_EVENT.NONE);
        };

        if (CheckMark === PARAMETER_EVENT.TOGGLE) {
            (body.classList.contains("rcpCursorBlack") && isboxId.classList.contains("rcpEnableFeature")) ? disableBlackCursor() : enableBlackCursor();
        } else if (CheckMark === PARAMETER_EVENT.ONLOAD) {
            enableBlackCursor();
        } else if (CheckMark === PARAMETER_EVENT.REMOVE) {
            disableBlackCursor();
        }
    }

    //  HIGHLIGHT FOCUS  //
    function highLightFocus(CheckMark) {
        let isboxId = document.querySelector("#highLightFocus");

        const enableHighlightFocus = () => {

            html.classList.add("rcpHighLightFocus");
            isboxId.classList.add("rcpEnableFeature");
            localStorage.setItem("rcp-highLight-focus", PARAMETER_EVENT.OPEN);
            activeIcon(PARAMETER_EVENT.BLOCK);
        };
        const disableHighlightFocus = () => {
            html.classList.remove("rcpHighLightFocus");
            isboxId.classList.remove("rcpEnableFeature");
            localStorage.removeItem("rcp-highLight-focus");
            activeIcon(PARAMETER_EVENT.NONE);
        };

        if (CheckMark === PARAMETER_EVENT.TOGGLE) {
            (html.classList.contains("rcpHighLightFocus") && isboxId.classList.contains("rcpEnableFeature")) ? disableHighlightFocus() : enableHighlightFocus();
        } else if (CheckMark === PARAMETER_EVENT.ONLOAD) {
            enableHighlightFocus();
        }
    }

    //  HIGHTLIGHT HOVER  //
    function highlightHover(CheckMark) {
        let isboxId = document.querySelector("#hightlightHover");

        const enableHighlightHover = () => {
            html.classList.add("rcpHighLightHover");
            isboxId.classList.add("rcpEnableFeature");
            localStorage.setItem("rcp-highlight-hover", PARAMETER_EVENT.OPEN);
            activeIcon(PARAMETER_EVENT.BLOCK);
        };

        const disableHighlightHover = () => {
            html.classList.remove("rcpHighLightHover");
            isboxId.classList.remove("rcpEnableFeature");
            localStorage.removeItem("rcp-highlight-hover");
            activeIcon(PARAMETER_EVENT.NONE);
        };

        if (CheckMark === PARAMETER_EVENT.TOGGLE) {
            (html.classList.contains("rcpHighLightHover") && isboxId.classList.contains("rcpEnableFeature")) ? disableHighlightHover() : enableHighlightHover();
        } else if (CheckMark === PARAMETER_EVENT.ONLOAD) {
            enableHighlightHover();
        }
    }

    //  HIDE IMAGES  //
    function hideImages(CheckMark) {
        let isboxId = document.querySelector("#hideImage");

        const enableHideImages = () => {
            html.classList.add("rcpHideImages");
            isboxId.classList.add("rcpEnableFeature");
            localStorage.setItem("rcp-hide-image", PARAMETER_EVENT.OPEN);
            activeIcon(PARAMETER_EVENT.BLOCK);
        };

        const disableHideImages = () => {
            html.classList.remove("rcpHideImages");
            isboxId.classList.remove("rcpEnableFeature");
            localStorage.removeItem("rcp-hide-image");
            activeIcon(PARAMETER_EVENT.NONE);
        };

        if (CheckMark === PARAMETER_EVENT.TOGGLE) {
            (html.classList.contains("rcpHideImages") && isboxId.classList.contains("rcpEnableFeature")) ? disableHideImages() : enableHideImages();
        } else if (CheckMark === PARAMETER_EVENT.ONLOAD) {
            enableHideImages();
        }
    }

    //  USEFUL LINKS  //
    function UseFulLinks(el) {
        if (el.match(/http(s?):/g)) {
            window.location.href = el;
        } else {
            const getElement = document.querySelector(el);
            getElement.scrollIntoView({ behavior: "smooth" });

        }
    }

    //  READING GUIDE  //
    function readingGuide(CheckMark) {
        let isboxId = document.querySelector("#readingGuide");

        let readingGuideCursor = document.querySelector(".rcp-reading-guide-cursor");
        if (!readingGuideCursor) {
            const cursorDiv = document.createElement("div");
            cursorDiv.className = "rcp-reading-guide-cursor";
            body.appendChild(cursorDiv);
            const arrowDiv = document.createElement("div");
            document.querySelector(".rcp-reading-guide-cursor").appendChild(arrowDiv);
            arrowDiv.className = "rcp-reading-guide-cursor-arrow";
        }

        const mouseMove = (e) => {
            const cursorDiv = document.querySelector(".rcp-reading-guide-cursor");

            if (document.body.contains(cursorDiv))
                cursorDiv.style.left = e.pageX + "px";
            if (document.body.contains(cursorDiv))
                cursorDiv.style.top = e.pageY - 0 + "px";
        }

        const enableReadingGuide = () => {
            body.classList.add("rcpReadingGuide");
            isboxId.classList.add("rcpEnableFeature");
            localStorage.setItem("rcp-reading-guide-curser", PARAMETER_EVENT.OPEN);
            activeIcon(PARAMETER_EVENT.BLOCK);
            body.addEventListener("mousemove", mouseMove);
        };

        const disableReadingGuide = () => {
            body.removeChild(readingGuideCursor);
            body.classList.remove("rcpReadingGuide");
            isboxId.classList.remove("rcpEnableFeature");
            localStorage.removeItem("rcp-reading-guide-curser");
            activeIcon(PARAMETER_EVENT.NONE);
            body.removeEventListener("mousemove", mouseMove);
        };

        if (CheckMark === PARAMETER_EVENT.TOGGLE) {
            (body.classList.contains("rcpReadingGuide") && isboxId.classList.contains("rcpEnableFeature")) ? disableReadingGuide() : enableReadingGuide();

        } else if (CheckMark === PARAMETER_EVENT.ONLOAD) {
            enableReadingGuide();
        }
    }

    //  READING MASK  //
    function readingMask(CheckMark) {
        let isboxId = document.querySelector("#readingMask");

        let readingMaskTop = document.querySelector(".rcpReadingMaskTop");
        let readingMaskBottom = document.querySelector(".rcpReadingMaskBottom");
        if (!readingMaskTop && !readingMaskBottom) {
            const topDiv = document.createElement("div");
            const bottomDiv = document.createElement("div");
            topDiv.className = "rcpReadingMaskTop";
            bottomDiv.className = "rcpReadingMaskBottom";
            body.appendChild(topDiv);
            body.appendChild(bottomDiv);
        }

        const mouseMove = (e) => {
            const maskTop = document.querySelector(".rcpReadingMaskTop");
            const maskBottom = document.querySelector(".rcpReadingMaskBottom");

            const th = e.y - 100;
            const tb = window.innerHeight - e.y - 100;

            if (document.body.contains(maskTop)) maskTop.style.height = th + "px";
            if (document.body.contains(maskBottom)) maskBottom.style.height = tb + "px";
        }

        const enableReadingMask = () => {
            body.classList.add("rcp-readingMask");
            isboxId.classList.add("rcpEnableFeature");
            localStorage.setItem("rcp-reading-mask", PARAMETER_EVENT.OPEN);
            activeIcon(PARAMETER_EVENT.BLOCK);
            body.addEventListener("mousemove", mouseMove);
        };

        const disableReadingMask = () => {
            body.removeChild(readingMaskTop);
            body.removeChild(readingMaskBottom);
            body.classList.remove("rcp-readingMask");
            isboxId.classList.remove("rcpEnableFeature");
            localStorage.removeItem("rcp-reading-mask");
            activeIcon(PARAMETER_EVENT.NONE);
            body.removeEventListener("mousemove", mouseMove);
        };

        const disableAdhdFriendlyProfile = () => {
            body.classList.remove("rcp-adhd-friendly-profile");
            localStorage.removeItem("rcp-adhd-friendly-profile");
            activeIcon(PARAMETER_EVENT.NONE);
        };

        if (CheckMark === PARAMETER_EVENT.TOGGLE) {
            if (body.classList.contains("rcp-adhd-friendly-profile")) { disableAdhdFriendlyProfile() }
            (body.classList.contains("rcp-readingMask") && isboxId.classList.contains("rcpEnableFeature")) ? disableReadingMask() : enableReadingMask();
        } else if (CheckMark === PARAMETER_EVENT.ONLOAD) {
            enableReadingMask();
        } else if (CheckMark === PARAMETER_EVENT.REMOVE) {
            disableReadingMask();
        }
    }

    //  MUTE SOUND  //
    function muteSound(CheckMark) {
        let isBoxId = document.querySelector("#muteSound");
        const iframes = document.querySelectorAll("iframe");
        const allMedia = document.querySelectorAll("audio,video");

        const enableMuteSound = () => {
            isBoxId.classList.add("rcpEnableFeature");
            iframes.forEach((iframe) => {
                if (!iframe.src.includes("&muted=true&mute=true&volume=0")) {
                    const srcValue = `${iframe.src}&muted=true&mute=true&volume=0`;
                    iframe.setAttribute("src", srcValue);
                }
            });
            allMedia.forEach((media) => {
                media.muted = true;
            });
            localStorage.setItem("rcp-mute-sound", PARAMETER_EVENT.OPEN);
            activeIcon(PARAMETER_EVENT.BLOCK);
        };

        const disableMuteSound = () => {
            isBoxId.classList.remove("rcpEnableFeature");
            iframes.forEach((iframe) => {
                const newValue = iframe.src.replace("&muted=true&mute=true&volume=0", "");
                iframe.setAttribute("src", newValue);
            });
            allMedia.forEach((media) => {
                media.muted = false;
            });
            localStorage.removeItem("rcp-mute-sound");
            activeIcon(PARAMETER_EVENT.NONE);
        };

        if (CheckMark === PARAMETER_EVENT.TOGGLE) {
            (isBoxId.classList.contains("rcpEnableFeature")) ? disableMuteSound() : enableMuteSound();
        } else if (CheckMark === PARAMETER_EVENT.ONLOAD) {
            enableMuteSound();
        }
    }

    //  STOP ANIMATIONS  //
    function animationsStop(CheckMark) {
        let isBoxId = document.querySelector("#animationsStop");
        let marquees = document.querySelectorAll("marquee");

        const stopAnimations = () => {
            body.classList.add("rcpStopAnimations");
            isBoxId.classList.add("rcpEnableFeature");
            marquees.forEach(marquee => marquee.stop());
            localStorage.setItem("rcp-animations-stop", PARAMETER_EVENT.OPEN);
            activeIcon(PARAMETER_EVENT.BLOCK);
        };

        const startAnimations = () => {
            body.classList.remove("rcpStopAnimations");
            isBoxId.classList.remove("rcpEnableFeature");
            marquees.forEach(marquee => marquee.start());
            localStorage.removeItem("rcp-animations-stop");
            activeIcon(PARAMETER_EVENT.NONE);
        };

        if (CheckMark === PARAMETER_EVENT.TOGGLE) {
            (body.classList.contains("rcpStopAnimations") && isBoxId.classList.contains("rcpEnableFeature")) ? startAnimations() : stopAnimations();
        } else if (CheckMark === PARAMETER_EVENT.ONLOAD) {
            stopAnimations();
        }
    }

    //  READ MODE  //
    let hasRunOneTimeReadMode = false;

    function readMode(CheckMark) {
        if (hasRunOneTimeReadMode) return;

        const isBoxId = document.querySelector("#readMode");
        let mainElement = document.createElement("main");
        mainElement.className += "rcpReadModeMain";
        const elements = document.querySelectorAll(ALL_ELEMENTS);
        const divs = document.querySelectorAll("body div:not(#progatixWidget div), body section:not(#progatixWidget section), body nav:not(#progatixWidget nav), body header:not(#progatixWidget header), body footer:not(#progatixWidget footer), body video:not(#progatixWidget video), body iframe:not(#progatixWidget iframe), body marquee:not(#progatixWidget marquee)");

        const applyReadMode = () => {
            body.appendChild(mainElement);
            body.classList.add("rcpReadMode");
            isBoxId.classList.add("rcpEnableFeature");

            elements.forEach(el => {

                let createTag;

                switch (el.tagName) {
                    case ELEMENTS.IMG:
                        createTag = document.createElement("img");
                        createTag.src = el.src;
                        createTag.alt = el.alt;
                        createTag.className = "rcpImageStylewidgetReadMode";
                        break;
                    case ELEMENTS.A:
                        createTag = document.createElement("a");
                        createTag.href = el.href || "";
                        createTag.className = "rcpLinkStylewidgetReadMode";
                        break;
                    case ELEMENTS.BUTTON:
                        createTag = document.createElement("a");
                        createTag.href = el.href || "";
                        createTag.className = "rcpLinkStylewidgetReadMode";
                        break;
                    case ELEMENTS.LINK:
                        createTag = document.createElement("a");
                        createTag.href = el.href || "";
                        createTag.className = "rcpLinkStylewidgetReadMode";
                        break;
                    default:
                        if ([ELEMENTS.H1, ELEMENTS.H2, ELEMENTS.H3, ELEMENTS.H4, ELEMENTS.H5, ELEMENTS.H6].includes(el.tagName)) {
                            createTag = document.createElement("h1");
                            createTag.className = "rcpHeadingStylewidgetReadMode";
                        } else {
                            createTag = document.createElement("p");
                            createTag.className = "rcpParagraphStylewidgetReadMode";
                        }
                        break;
                }

                createTag.innerHTML = el.innerText;
                mainElement.appendChild(createTag);
            });

            divs.forEach(div => {
                if (div.id !== "progatixWidgetRoot") {
                    div.setAttribute(WIDGET_CLASS_ATTRIBUTES.ACCESSIBILITY_READMODE_HIDE, PARAMETER_EVENT.NONE);
                }
            });

            localStorage.setItem("rcp-read-mode", PARAMETER_EVENT.OPEN);
            activeIcon(PARAMETER_EVENT.BLOCK);
        };

        const removeReadMode = () => {
            let mainElement = document.querySelector(".rcpReadModeMain");
            body.removeChild(mainElement);
            body.classList.remove("rcpReadMode");
            isBoxId.classList.remove("rcpEnableFeature");

            elements.forEach(el => { el.removeAttribute(WIDGET_CLASS_ATTRIBUTES.ACCESSIBILITY_READMODE_HIDE) });

            localStorage.removeItem("rcp-read-mode");
            activeIcon(PARAMETER_EVENT.NONE);
        };

        if (CheckMark === PARAMETER_EVENT.TOGGLE) {
            (body.classList.contains("rcpReadMode") && isBoxId.classList.contains("rcpEnableFeature")) ? removeReadMode() : applyReadMode();
        } else if (CheckMark === PARAMETER_EVENT.ONLOAD) {
            applyReadMode();
        }

        hasRunOneTimeReadMode = true;
    }

    return { cursorWhite, cursorBlack, highLightFocus, highlightHover, hideImages, UseFulLinks, readingGuide, readingMask, muteSound, animationsStop, readMode }
}

export default useOrientationAdjustment